import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions(['subscribeUser']),
    async handleSubscribeUser(payload) {
      return await this.subscribeUser({ ...payload })
    }
  }
}